import React, { useState, useEffect } from "react";
import blankProfileImage from "../../assets/images/blank-profile-picture1280.png";
import UserLabResult from "./user-lab-result/UserLabResult";

import { NOTCHANGEABLE_PROFILE_DATA } from "components/constants/profileFields";
import UserTextField from "./UserTextField";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  errorClean,
  getLoggedInUser,
  messageClean,
  removeUserProfileImage,
  updateUserProfileImage,
} from "redux-store/user/user.slice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { successMessage, user } from "redux-store/user/user.selectors";
import { test } from "redux-store/lab-tests/tests.selecter";
import { getTests } from "redux-store/lab-tests/tests.slice";
import LabResultTable from "components/dashboard/lab-result/LabResultTable";

const UserProfile = () => {
  const { userId } = useParams();

  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector(user);
  const editMessage = useSelector(successMessage);

  const [imageUploading, setImageUploading] = useState(false);
  const [formData, setFormData] = useState({
    profile: userData?.profile,
  });

  const [userForm, setUserForm] = useState({
    fullName: userData?.fullName,
    email: userData?.email,
    firstName: userData?.firstName,
    lastName: userData?.lastName,
    phone: userData?.phone,
    address: userData?.address,
    profile: userData?.profile,
  });
  const [errMessages, setMessages] = useState({
    imageMessage: "",
  });

  const tests = useSelector(test);
  useEffect(() => {
    !userData?.isAdmin && dispatch(getTests());
  }, []);

  async function handleImages(e: any) {
    const name = e.target.name;

    const file = e.target.files[0];
    if (!file?.name?.match(/\.(jpg|jpeg|png|webp|avif)$/)) {
      setMessages({
        ...errMessages,
        imageMessage: name === "profile" ? "Invalid File" : "",
      });
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setMessages({
        ...errMessages,
        imageMessage: name === "profile" ? "Invalid File Size" : "",
      });
      return;
    }
    setMessages({
      ...errMessages,
      imageMessage: "",
    });
    setFormData({ profile: file });
  }

  async function uploadProfileImageHandler() {
    setImageUploading(true);
    dispatch(errorClean());
    if (editMessage !== "") {
      dispatch(messageClean());
    }
    const profileImage = new FormData();
    profileImage.append("profile", formData.profile);

    await dispatch(updateUserProfileImage(profileImage));
    setImageUploading(false);
  }

  function deleteProfileImageHandler() {
    dispatch(removeUserProfileImage());
  }

  useEffect(() => {
    if (formData.profile !== "") {
      uploadProfileImageHandler();
      setFormData({ profile: "" });
    }
  }, [formData.profile]);

  useEffect(() => {
    try {
      dispatch(getLoggedInUser());
    } catch (error) {
      console.log(error);
    }
  }, [userData?.profile]);

  useEffect(() => {
    userData &&
      setUserForm({
        fullName: userData?.fullName,
        email: userData?.email,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        phone: userData?.phone,
        address: userData?.address,
        profile: userData?.profile,
      });
  }, [userData]);

  return (
    <React.Fragment>
      <div className="tw-flex tw-justify-center">
        <div className="tw-w-[90%] tw-py-3 tw-bg-[#FFFFFF] tw-rounded-xl tw-shadow-3xl">
          <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-px-5 min-[375]::tw-px-10">
            <div className=" tw-text-black tw-flex tw-items-center">
              <div className="tw-text-[20px] md:tw-text-[26px] lg:tw-text-3xl tw-font-bold">
                Personal Info
              </div>
            </div>
            <div className="tw-pt-4 lg:tw-pt-7 tw-flex tw-flex-col min-[375px]:tw-flex-row">
              <Link
                to={`/${
                  userData?.isAdmin ? "admin" : "user"
                }/edit-profile/${userId}`}
                className="tw-border-2 tw-text-[16px] md:tw-text-[20px] tw-rounded-[10px] tw-px-7 2xl:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-border-black tw-text-black hover:tw-bg-slate-200 hover:tw-border-slate-200 hover:tw-text-black cursor-pointer"
              >
                Edit
              </Link>
              <Link
                to={`${userData?.isAdmin ? "/admin/dashboard" : "/user/home"}`}
                className="tw-text-white tw-text-[16px] md:tw-text-[20px] tw-border-2 tw-px-7 2xl:tw-px-[40px] tw-mt-5 min-[375px]:tw-ml-5 min-[375px]:tw-mt-0 tw-py-2 lg:tw-py-3 tw-rounded-[10px] tw-border-reddishOrange tw-bg-reddishOrange hover:tw-text-white hover:tw-bg-darkRed hover:tw-border-darkRed tw-cursor-pointer"
              >
                Back
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-flex tw-justify-center">
        <div className="tw-mt-3 tw-w-[90%] tw-py-3 tw-bg-[#FFFFFF] tw-rounded-xl tw-shadow-3xl">
          <div className="tw-flex">
            <div className="tw-justify-start tw-px-[5%] lg:tw-px-[20%]">
              <div className="tw-text-[20px] md:tw-text-[26px] lg:tw-text-3xl tw-font-bold tw-text-black tw-pt-6">
                Edit your profile
              </div>
              <div className="tw-flex tw-flex-col lg:tw-flex-row tw-items-start lg:tw-items-end tw-pb-6">
                <img
                  src={
                    userForm?.profile ? userForm?.profile : blankProfileImage
                  }
                  alt="profile"
                  className="tw-h-[200px] tw-w-[200px] lg:tw-h-[300px] lg:tw-w-[300px] tw-object-cover tw-rounded-3xl tw-inline-block tw-mt-10"
                />

                <div className="tw-inline-block tw-pt-5 lg:tw-pt-0 tw-pl-0 lg:tw-pl-9">
                  <div className="tw-text-[20px] md:tw-text-[26px] lg:tw-text-3xl tw-font-bold tw-text-black">
                    Your Profile
                  </div>
                  <div className="tw-text-sm lg:tw-text-base">
                    For best quality use a 300 x 300 px image
                  </div>
                  <div className="tw-pt-4 lg:tw-pt-7 tw-flex tw-flex-col min-[375px]:tw-flex-row">
                    <button
                      onClick={deleteProfileImageHandler}
                      className="tw-border-2 tw-text-[16px] md:tw-text-[20px] tw-rounded-[10px] tw-px-[36px] sm:tw-px-[40px] tw-py-2 lg:tw-py-3 tw-border-black tw-text-black hover:tw-bg-slate-200 hover:tw-border-slate-200 hover:tw-text-black cursor-pointer"
                    >
                      Remove
                    </button>
                    <button className="tw-text-white tw-text-[16px] md:tw-text-[20px] tw-border-2  tw-px-[36px] sm:tw-px-[40px] tw-mt-5 min-[375px]:tw-ml-5 min-[375px]:tw-mt-0 tw-py-2 lg:tw-py-3 tw-rounded-[10px] tw-border-reddishOrange tw-bg-reddishOrange hover:tw-text-white hover:tw-bg-darkRed hover:tw-border-darkRed tw-cursor-pointer">
                      <input
                        className="hover:tw-cursor-pointer tw-absolute tw-opacity-0 tw-w-[15%]"
                        type="file"
                        name="profile"
                        onChange={handleImages}
                      />
                      Upload
                    </button>
                  </div>
                  {imageUploading && (
                    <p className="tw-text-gray-800 tw-text-lg tw-mt-2 tw-pt-3">
                      Loading...
                    </p>
                  )}
                  <p className="tw-mt-2 tw-text-xs md:tw-text-sm tw-text-red-500">
                    {(errMessages as any)["imageMessage"]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Data*/}
      <div className="tw-flex tw-justify-center">
        <div className="tw-mt-3 tw-w-[90%] tw-py-3 tw-bg-[#FFFFFF] tw-rounded-xl tw-shadow-3xl">
          <div className="tw-flex ">
            <div className="tw-flex tw-flex-wrap tw-justify-between tw-px-[5%] lg:tw-px-[19%]">
              {NOTCHANGEABLE_PROFILE_DATA.map((value) => {
                return (
                  <div
                    className="tw-py-5 tw-w-full sm:tw-w-96 lg:tw-w-80"
                    key={value.name}
                  >
                    <UserTextField
                      className="tw-w-full sm:tw-w-96 lg:tw-w-80"
                      label={value?.label}
                      defaultValue={
                        userForm && (userForm as any)[value?.name]
                          ? (userForm as any)[value?.name]
                          : ""
                      }
                      readOnly={true}
                      focused
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="tw-flex tw-justify-center ">
        <div className="tw-w-[95%] tw-py-5 tw-bg-[#FFFFFF] tw-rounded-xl tw-shadow-3xl">
          <div className="tw-flex tw-justify-between tw-px-10">
            <div className=" tw-text-black tw-flex tw-items-center">
              <div className="tw-text-2xl tw-font-bold">Lab Test Results</div>
            </div>
          </div>
        </div>
      </div>
      {userData?.isAdmin ? (
        <LabResultTable />
      ) : (
        <UserLabResult labTests={tests} />
      )}
    </React.Fragment>
  );
};

export default UserProfile;
